import { useAuthStateValue } from '@/auth/authentication';
import { useAppConfig } from '@/fetching/api/appConfig';
import { envVars } from '@/utils/envVars';
import { useEffect } from 'react';

import { isPylonEnabledForEnvironment, loadPylonWidget } from './pylon.utils';

export const PylonWidget = () => {
    const { support_chat_widget: isEnabledForOrganization } = useAppConfig();
    const authState = useAuthStateValue();

    // Pylon recomputes the digest over the address sent with it and rejects the pair
    //  unless they match, so both come from the same sign-in response.
    const email = authState?.pylonEmail;
    const emailHash = authState?.pylonEmailHash;
    const name = [authState?.firstName, authState?.lastName].filter(Boolean).join(' ');

    const shouldLoad =
        isEnabledForOrganization && !!email && !!emailHash && isPylonEnabledForEnvironment();

    useEffect(() => {
        if (!shouldLoad || !email || !emailHash) {
            return;
        }

        return loadPylonWidget({
            app_id: envVars.pylonAppId,
            email: email,
            name: name || email,
            email_hash: emailHash,
        });
    }, [shouldLoad, email, emailHash, name]);

    return null;
};
